import { c as _c } from "react/compiler-runtime";
import ItemContent from 'modules/stores/store/components/item-content';
import ItemWrapper from 'modules/stores/store/components/item-wrapper';
import { useOptinActions } from 'modules/stores/store/content/optin/hooks/use-optin-actions';
import { OptinItemViewType } from 'modules/stores/store/content/optin/types/optin-interface';
import { useDeleteItem } from 'modules/stores/store/hooks/use-delete-item';
import { useChangeItemDraft } from '../../hooks/use-change-item-draft';
import { getOptinUpdateData } from './utils/get-optin-update-data';
const OptinContent = optinView => {
  const $ = _c(25);
  const {
    deleteOptin,
    updateOptin
  } = useOptinActions();
  const {
    onDelete
  } = useDeleteItem();
  let t0;
  if ($[0] !== deleteOptin || $[1] !== onDelete || $[2] !== optinView.id || $[3] !== optinView.itemId) {
    t0 = () => onDelete({
      deleteCallback: () => deleteOptin(optinView.id),
      itemId: optinView.itemId
    });
    $[0] = deleteOptin;
    $[1] = onDelete;
    $[2] = optinView.id;
    $[3] = optinView.itemId;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const onDeleteOptin = t0;
  const {
    onChangeItemDraft
  } = useChangeItemDraft();
  let t1;
  if ($[5] !== onChangeItemDraft || $[6] !== optinView || $[7] !== updateOptin) {
    t1 = () => onChangeItemDraft({
      callback: async () => {
        await updateOptin(optinView.id, getOptinUpdateData({
          ...optinView,
          draft: true
        }));
      },
      itemId: optinView.itemId,
      draft: true
    });
    $[5] = onChangeItemDraft;
    $[6] = optinView;
    $[7] = updateOptin;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const onSaveDraft = t1;
  let t2;
  if ($[9] !== onChangeItemDraft || $[10] !== optinView || $[11] !== updateOptin) {
    t2 = () => onChangeItemDraft({
      callback: async () => {
        await updateOptin(optinView.id, getOptinUpdateData({
          ...optinView,
          draft: false
        }));
      },
      itemId: optinView.itemId,
      draft: false
    });
    $[9] = onChangeItemDraft;
    $[10] = optinView;
    $[11] = updateOptin;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const onPublish = t2;
  let t3;
  if ($[13] !== onDeleteOptin || $[14] !== onPublish || $[15] !== onSaveDraft || $[16] !== optinView.draft || $[17] !== optinView.itemId || $[18] !== optinView.thumbnail || $[19] !== optinView.title || $[20] !== optinView.type) {
    t3 = <ItemContent draft={optinView.draft} onDelete={onDeleteOptin} onSaveDraft={onSaveDraft} onPublish={onPublish} itemId={optinView.itemId} title={optinView.title} itemType={optinView.type} thumbnail={optinView.thumbnail} />;
    $[13] = onDeleteOptin;
    $[14] = onPublish;
    $[15] = onSaveDraft;
    $[16] = optinView.draft;
    $[17] = optinView.itemId;
    $[18] = optinView.thumbnail;
    $[19] = optinView.title;
    $[20] = optinView.type;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== optinView.itemId || $[23] !== t3) {
    t4 = <ItemWrapper id={optinView.itemId}>{t3}</ItemWrapper>;
    $[22] = optinView.itemId;
    $[23] = t3;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  return t4;
};
export default OptinContent;